import React from "react";
import video1 from "assets/images/website/features-management.svg";
import video2 from "assets/videos/website/features2.mp4";
import video3 from "assets/videos/website/features3.mp4";

const Features: React.FC = () => {
  return (
    <section id="features" className="bg-secondary-50/60 dark:bg-secondary-900/30 border-y border-secondary-200/60">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <div className="flex w-full flex-col items-center justify-center gap-10 md:gap-16 max-md:overflow-x-scroll max-md:overflow-y-hidden">
          <div className="flex flex-col md:flex-row gap-4 md:gap-0 md:justify-between md:items-center w-full">
            <h2
              className="text-[32px] 
leading-[38px] font-[500] tracking-[-0.6px] md:text-[48px] md:leading-[54px] md:font-[450] md:tracking-[-1.2px] flex-shrink-0"
            >
              Features
            </h2>
            <p className="text-[16px] leading-[22px] font-[400] text-gray-500 tracking-[-0.2%]">
              Your card is just the beginning.
            </p>
          </div>
          <div className="flex gap-4 max-xl:hidden">
            <div className="bg-[#F6F7F9] rounded-[12px] w-[300px] h-[353px] md:w-[405px] md:h-[424px]flex flex-col">
              <div className="pt-4 md:pt-8 h-[200px] md:h-[260px] flex items-center justify-center">
                {/* <video
                  playsInline
                  muted
                  autoPlay
                  loop
                  preload="auto"
                  className="h-[228px] "
                >
                  <source
                    src={video1}
                    type="video/mp4"
                  />
                  Your browser does not support the video tag.
                </video> */}
                <img src={video1} alt="Feature Management" className="w-[236px] h-[136px]" />
              </div>
              <div className="p-4 md:p-8 h-[123px] md:h-[164px] flex flex-col gap-2">
                <p className="md:text-[20px] md:leading-[26px] font-[450] md:tracking-[-0.3px]">
                  Own your network
                </p>
                <p
                  className="text-[16px] 
 leading-[22px] font-[400] text-gray-500 tracking-[-0.2%]"
                >
                  Keep every connection in one powerful place. Add notes,
                  context, and never lose track of a relationship.
                </p>
              </div>
            </div>
            <div
              className="bg-[#F6F7F9] rounded-[12px] w-[300px] h-[353px] md:w-[405px] 
 md:h-[424px] flex flex-col"
            >
              <div className="pt-4 md:pt-8 h-[200px] md:h-[260px] flex items-center justify-center">
                {/* <video
                  playsInline
                  muted
                  autoPlay
                  loop
                  preload="auto"
                  className="h-[228px] rounded-[30px] w-[342px]"
                >
                  <source
                    src={video2}
                    type="video/mp4"
                  />
                  Your browser does not support the video tag.
                </video> */}
                <img src={video1} alt="Feature Management" className="w-[236px] h-[136px]" />
              </div>
              <div className="p-4 md:p-8 h-[123px] md:h-[164px] flex flex-col gap-2">
                <p className="md:text-[20px] md:leading-[26px] font-[450] md:tracking-[-0.3px]">
                  Capture everything
                </p>
                <p className="text-[16px] leading-[22px] font-[400] text-gray-500 tracking-[-0.2%]">
                  Scan paper cards, digital profiles, QR codes, even event
                  badges — AI handles it all in seconds.
                </p>
              </div>
            </div>
            <div className="bg-[#F6F7F9] rounded-[12px] w-[300px] h-[353px] md:w-[405px] md:h-[424px] flex flex-col">
              <div className="pt-4 md:pt-8 h-[200px] md:h-[260px] flex items-center justify-center">
                {/* <video
                  playsInline
                  muted
                  autoPlay
                  loop
                  preload="auto"
                  className="h-[228px] rounded-[16px]"
                >
                  <source
                    src={video3}
                    type="video/mp4"
                  />
                  Your browser does not support the video tag.
                </video> */}
                <img src={video1} alt="Feature Management" className="w-[236px] h-[136px]" />
              </div>
              <div className="p-4 md:p-8 h-[123px] md:h-[164px] flex flex-col gap-2">
                <p className="md:text-[20px] md:leading-[26px] font-[450] md:tracking-[-0.3px]">
                  Share instantly
                </p>
                <p className="text-[16px] leading-[22px] font-[400] text-gray-500 tracking-[-0.2%]">
                  Send your card with a single tap — by email, social, or
                  straight to your Apple and Google Wallets.
                </p>
              </div>
            </div>
          </div>
          <div
  className="relative mt-3 w-full xl:hidden"
  role="region"
  aria-roledescription="carousel"
>
  <div className="overflow-x-auto snap-x snap-mandatory scrollbar-hide">
    <div className="flex -ml-4 gap-4">
      
      {/* Slide 1 */}
      <div
        className="snap-start min-w-[100%] md:min-w-[80%] lg:min-w-[70%] shrink-0 flex items-center justify-center pl-4 pt-4"
      >
        <div className="bg-[#F6F7F9] rounded-[12px] w-[300px] h-[353px] md:w-[405px] md:h-[424px] flex flex-col">
          <div className="pt-4 md:pt-8 h-[200px] md:h-[260px] flex items-center justify-center">
            {/* <video playsInline muted autoPlay loop preload="auto" className="h-[228px]">
              <source src={video1} type="video/mp4" />
            </video> */}
                <img src={video1} alt="Feature Management" className="w-[236px] h-[136px]" />
          </div>
          <div className="p-4 md:p-8 flex flex-col gap-2 ">
            <p className="md:text-[20px] md:leading-[26px] font-[450]">Own your network</p>
            <p className="text-[16px] leading-[22px] text-gray-500">
              Keep every connection in one powerful place.
            </p>
          </div>
        </div>
      </div>

      {/* Slide 2 */}
      <div
        className="snap-start min-w-[100%] md:min-w-[80%] lg:min-w-[70%] shrink-0 flex items-center justify-center pl-4 pt-4"
      >
        <div className="bg-[#F6F7F9] rounded-[12px] w-[300px] h-[353px] md:w-[405px] md:h-[424px] flex flex-col">
          <div className="pt-4 md:pt-8 h-[200px] md:h-[260px] flex items-center justify-center">
            {/* <video playsInline muted autoPlay loop preload="auto" className="h-[228px] rounded-[30px] w-[342px]">
              <source src={video2} type="video/mp4" />
            </video> */}
            
                <img src={video1} alt="Feature Management" className="w-[236px] h-[136px]" />
          </div>
          <div className="p-4 md:p-8 flex flex-col gap-2">
            <p className="md:text-[20px] md:leading-[26px] font-[450]">Capture everything</p>
            <p className="text-[16px] leading-[22px] text-gray-500">
              Scan paper cards, digital profiles, QR codes...
            </p>
          </div>
        </div>
      </div>

      {/* Slide 3 */}
      <div
        className="snap-start min-w-[100%] md:min-w-[80%] lg:min-w-[70%] shrink-0 flex items-center justify-center pl-4 pt-4"
      >
        <div className="bg-[#F6F7F9] rounded-[12px] w-[300px] h-[353px] md:w-[405px] md:h-[424px] flex flex-col">
          <div className="pt-4 md:pt-8 h-[200px] md:h-[260px] flex items-center justify-center">
            {/* <video playsInline muted autoPlay loop preload="auto" className="h-[228px] rounded-[16px]">
              <source src={video3} type="video/mp4" />
            </video> */}
            
                <img src={video1} alt="Feature Management" className="w-[236px] h-[136px]" />
          </div>
          <div className="p-4 md:p-8 flex flex-col gap-2">
            <p className="md:text-[20px] md:leading-[26px] font-[450]">Share instantly</p>
            <p className="text-[16px] leading-[22px] text-gray-500">
              Send your card with one tap...
            </p>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>

        </div>
      </div>
    </section>
  );
};

export default Features;
